import * as React from "react";

const SvgClothes = ({ active }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 290.625 290.625"
    style={{
      enableBackground: "new 0 0 290.625 290.625",
      width: "50px",
      height: "50px",
    }}
    xmlSpace="preserve"
  >
    <path
      style={{ fill: active === 3 ? "white" : "#e9ebf0" }}
      d="m257.297 85.683-70.941-28.378-.023-.056L150 43.627V23.438C150 10.514 139.486 0 126.563 0c-12.923 0-23.438 10.514-23.438 23.438v4.688h9.375v-4.688c0-7.753 6.309-14.063 14.063-14.063 7.754 0 14.063 6.309 14.063 14.063v20.189l-36.333 13.622-.023.056-70.942 28.378-20.076 115.439 57.061 4.753v84.75h150v-84.75l57.06-4.753-20.076-115.439zm-66.854 4.959-32.48 8.859 23.621-29.526 8.859 20.667zm-45.131-38.761 29.798 11.175-29.798 37.252-29.798-37.252 29.798-11.175zm-36.271 18.094 23.62 29.527-32.48-8.859 8.86-20.668zM70.312 196.467l-46.064-3.839 1.664-9.572 44.4 4.036v9.375zm150-18.787v-51.118h-9.375V281.25H79.688V126.562h-9.375v51.118l-42.788-3.891 14.147-81.347 57.375-22.95-11.728 27.361 53.306 14.541V262.5H150V111.394l53.306-14.536-11.728-27.361 57.375 22.95 14.147 81.347-42.788 3.886zm.001 9.412 44.4-4.036 1.664 9.572-46.064 3.839v-9.375z"
    />
  </svg>
);

export default SvgClothes;
